<template>
    <!-- <NuxtLayout name='master'> -->
    <div class="flex flex-col justify-between bg-white dark:bg-grey-2000"
        :class='{
            "min-h-screen": !adminOverride,
        }'
    >
        <template v-if="lUser !== null && adminOverride == false">
            <SignUpNav v-if="lUser.currentView() == 'sign-up' || lUser.currentView() == 'onboarding'" 
                :user="lUser" :adminOverride="adminOverride" :adminCompany="adminCompany" 
            />
            <AppNav v-if="lUser.currentView() == 'app'"/>
            <ZapoNav v-if="lUser.currentView() == 'zapo'" />
        </template>

        <div class='w-screen z-10 bg-coal sticky top-0'>
            <div class="max-w-page mx-auto w-full">
                <CallToast v-if='$twilio && $twilio.active' 
                    :call="$twilio.active" :isNav='true' />
            </div>
        </div>

        <div
            class="bg-white dark:bg-grey-2000 w-full h-full absolute inset-0 z-40 flex items-center justify-center"
            :style="{
                'min-height: calc(100% - 80px)': lUser != null && lUser.currentView() == 'app',
                'min-height: calc(100% - 96px)': lUser != null && lUser.currentView() == 'sign-up' && !adminOverride,
            }"
            v-if="!canSeePage"
        >
            <ClientOnly>
                <Vue3Lottie :animationData="ZapoLogoJson" :height="100" :width="100" :loop="true" @onLoopComplete="onLoopComplete" />
            </ClientOnly>
        </div>

        <div
            class="mb-auto relative"
            v-show="canSeePage"
            :style="{
                'min-height: calc(100vh - 80px)': lUser != null && lUser.currentView() != 'sign-up',
                'min-height: calc(100vh - 96px)': lUser != null && lUser.currentView() == 'sign-up' && !adminOverride,
            }"
        >
            <slot name='above' />

            <slot />
        </div>
        <!-- h-[0px] flex flex-col-reverse gap-2 -->
        <div class="fixed bottom-7 right-6 flex flex-col gap-2">
            <Toast v-for="toast in toasts" :message="toast" />

            <!-- <Toast v-if='$twilio' v-for="call in $twilio.calls" :call="call" /> -->
            
            <CallToast v-if='$twilio' v-for="call in $twilio.calls" :call="call" />

            <!-- <p>{{ calls }}</p> -->
        </div>

        <ModalCreateAll />

        <slot name="footer" />
    </div>
    <!-- </NuxtLayout> -->
</template>

<script>
import { RouterView } from 'vue-router'
import AppNav from '~/components/customer/navs/app.vue'
import SignUpNav from '~/components/customer/navs/sign-up.vue'
import ZapoNav from '~/components/customer/navs/zapo.vue'
import Toast from '~/components/customer/blocks/toast.vue'
import CallToast from '~/components/customer/blocks/call-toast.vue';
import ZapoLogoJson from '~/assets/animation-zapo-loading.json'
import MasterLayoutMixin from '~/mixins/master-mixin.js'
import { useIntercom } from '@homebaseai/vue3-intercom'

export default {
    // mixins: [Twilio],
    mixins: [MasterLayoutMixin],

    props: {
        adminOverride: { type: Boolean, default: false },
        adminCompany: { type: Object, default: null },
        user: { type: Object, default: null },
    },

    mounted() {
        this.$event.$on('toast-new-message', (toast) => {
            this.toasts.push(toast)
        })
    },

    data() {
        return {
            timeout: null,
            ZapoLogoJson,
            toasts: [],
            canSeePage: false,
        }
    },

    methods: {
        // onLoopComplete() {
        //     if (!this.pageLoading) {
        //         this.canSeePage = true
        //     }
        // },
    },

    computed: {
        lUser() {
            return this.user || this.$authSanctum.getUser()
        },

        canSeePage() {
            return !this.pageLoading
        }
    },

    watch: {
        '$route'(to, from) {
            // Navigating between nested children of the same top-level page
            // (e.g. the company page tabs) reuses the parent component, which
            // owns the data and never re-emits `page-loaded`. Showing the
            // global loader in that case leaves it stuck on screen forever.
            // RouterView parents (tools/reports) are excluded because their
            // children are full pages that load their own data and do emit it.
            const toRoot = to.matched[0]
            const fromRoot = from.matched[0]
            const sameOwningPage =
                toRoot != null &&
                toRoot === fromRoot &&
                toRoot.components?.default !== RouterView

            if (to.path !== from.path && !sameOwningPage) {
                this.pageLoading = true
            }
        }
    },

    components: {
        AppNav,
        SignUpNav,
        ZapoNav,
        Toast,
        CallToast
    },
}
</script>
